
<template>
  <div class="payment-screen">
    <img src="https://info.vinapp.co/wp-content/uploads/2024/06/Logo-secundario.png" class="logo" />
    
    <div v-if="errorMessage" class="error-alert">
      {{ errorMessage }}
    </div>

    <div class="payment-container">
      <h2 class="payment-instructions" v-show="order.id_type_forma_pago == 39">
        Introduce, acerca o desliza tu tarjeta y sigue las instrucciones del Datáfono. Presione el botón verde del Datáfono para confirmar.
      </h2>

      <div class="total-amount">
        Total: ${{ new Intl.NumberFormat("de-DE").format(order.total) }}
      </div>

      <div class="dataphone-container">
        <div class="dataphone">
          <div class="screen"></div>
          <div class="card-slot"></div>
          <div class="keypad">
            <div class="display">
              <span class="visa-text">{{ text }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-button" @click="Volver()" :disabled="button_return">
      <div class="send-button" >
      <i class="fas fa-arrow-left"></i>
        <label class="send-text">Volver a la tienda</label>
      </div>
    </div>

  </div>
</template>


<script>
  //import axios from "axios";
  import axios from '@/config/axios';
  import BoldTerminalHelper from "../helpers/BoldTerminalHelper";
  
  export default {
    props: ["order", "onFinish"],
    data() {
      return {
        button_return:false,
        loadingCreate: false,
        loadingSearch: false,
        text: "",
        errorMessage: "",
        timer: null,
        timeLeft: 14 * 60, // Tiempo en segundos (14 minutos)
        showQR: true,
        kiosko:localStorage.getItem('kiosko'),
        bold_status: localStorage.getItem("bold_status") ? localStorage.getItem("bold_status") === 'true' ? true : false : false,
        bold_point_id: localStorage.getItem("bold_point_id"),
        bold_terminal: null,
      };
    },
    computed: {
      formattedTime() {
        const minutes = Math.floor(this.timeLeft / 60);
        const seconds = this.timeLeft % 60;
        return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
      },
    },
    methods: {
      Volver(){
				if(this.kiosko == false || this.kiosko == 'false' || this.kiosko == null){
					location.href = location.origin+'/'+this.$route.params.id
				}else{
					location.href = location.origin+'/'+this.$route.params.id+'?kiosko'
				}
			},
      async createOrder() {
        this.loadingCreate = true;
        this.button_return = true;
        this.text = "Creando Transacción...";
        this.errorMessage = "";
        if(this.bold_status){
          if(this.bold_terminal && this.bold_point_id){
            let form = {
              point_id: this.bold_point_id,
              amount: {
                currency: "COP",
                total_amount: this.order.total,
                taxes: [],
                tip_amount: 0,
              },
              reference: this.order.id_order,
              payment_method: "POS",
              terminal_model: this.bold_terminal.terminal_model,
              terminal_serial: this.bold_terminal.terminal_serial,
              user_email: this.bold_terminal.user_email,
              description: "Compra en establecimiento",
              payer: {
                name: "Consumidor Final",
                email: "consumidorfinal@gmail.com",
                phone: localStorage.getItem('Telefono_pedidos') ? localStorage.getItem('Telefono_pedidos') : '3000000000'
              }
            };
            try {
              let http = await axios.post('/api/config-bold/process-payment', form);
              this.loadingCreate = false;
      
              let response = http.data;
              if (response.success) {
                if (response.success) {
                  this.againValidationBold();
                } else {
                  this.errorMessage = 'Error al procesar el pago, contacte al administrador.';
                }
              } else {
                this.errorMessage = `Error: ${response.message}`;
              }
            } catch (error) {
              this.loadingCreate = false;
              this.errorMessage = "Ocurrió un error al intentar crear la transacción.";
            }
          } else{
            alert('Por favor indicar al encargado que seleccione una terminal para procesar las transacciones.')
          }
        } else{
          let form = {
            idCajero: "Cajero001",
            pointId: this.order.id_point,
            orderId: this.order.id_order,
            idDeTransaccion: this.order.id_order,
            numeroDeCaja: "Caja1",
            numeroDeFactura: this.order.id_order,
            valorIAC: 0,
            valorIVA: 0,
            valorPropina: this.order.service,
            valorVenta: this.order.total,
          };
          try {
            let http = await axios.post('/api/compra-tef', form);
            this.loadingCreate = false;
    
            let response = http.data;
            if (response.success) {
              if (response.compra.estado == "CREADA") {
                this.againValidation();
              } else {
                this.errorMessage = 'El backend devolvió un estado diferente de "CREADA". Validar escenario.';
              }
            } else {
              this.errorMessage = `Error: ${response.message}`;
            }
          } catch (error) {
            this.loadingCreate = false;
            this.errorMessage = "Ocurrió un error al intentar crear la transacción.";
          }
        }
      },
      async createOrderQRBancolombia(){
        this.loadingCreate = true;
        this.button_return = true;
        this.text = "Creando Transacción...";
        this.errorMessage = "";
      
        try {
          let http = await axios.post('/api/qr-code-bancolombia', {orderId: this.order.id_order});

          if(http.data.success){
            localStorage.setItem('qr_image_bancolombia', http.data.data.qr_image);
            location.href = location.pathname + '/order/' + http.data.data.order_id;
          }else{
            this.errorMessage = "Ocurrió un error al intentar crear la transacción.";
          }
          this.loadingCreate = false;
        } catch (error) {
          this.loadingCreate = false;
        }
      },
      againValidation() {
        setTimeout(() => {
          this.validatePaymentStatus();
        }, 5 * 1000);
      },
      againValidationBold() {
        setTimeout(() => {
          this.validatePaymentStatusBold();
        }, 5 * 1000);
      },
      async validatePaymentStatus() {
        this.loadingSearch = true;
        this.button_return = false;
        this.text = "Consultando Transacción...";
        this.errorMessage = "";
        try {
          let http = await axios.get('/api/compra-tef?pointId=' +this.order.id_point+ '&orderId=' +this.order.id_order+ '&idDeTransaccion=' +this.order.id_order);
  
          let response = http.data;
          if (/*response.data.estadoDeTransaccion == "CREADA" || */response.data.estadoDeTransaccion == "PENDIENTE") {
            this.againValidation();
          }
  
          if (response.data.estadoDeTransaccion == "PAGADA" || response.data.estadoDeTransaccion == "COMPLETADA" || response.data.estadoDeTransaccion == "CREADA") { //Descomentar para prueba
            //clearInterval(this.timer); // Detener el temporizador
            this.loadingSearch = false;
            this.text = "¡PAGO REALIZADO EXITOSAMENTE!";
            setTimeout(() => {
              this.onFinish(true);
            }, 1.5 * 1000);
          }

          if(response.data.estadoDeTransaccion == "RECHAZADA"){
            clearInterval(this.timer); // Detener el temporizador
            this.loadingSearch = false;
            this.errorMessage = "PAGO RECHAZADO";
            this.text = "PAGO RECHAZADO";
            setTimeout(() => {
              this.onFinish(false);
            }, 1.5 * 1000);
          }


  
          if (response.data.estadoDeTransaccion == "ERROR") {
            this.errorMessage = "Ocurrió un error al consultar el estado de la transacción.";
          }
          
        } catch (error) {
          this.loadingSearch = false;
        }
      },
      async validatePaymentStatusBold() {
        this.loadingSearch = true;
        this.button_return = false;
        this.text = "Consultando Transacción...";
        this.errorMessage = "";
        try {
          let http = await axios.get('/api/bold/transaction-status/'+this.order.id_order);
  
          let response = http.data;
          if (response.data.status == "pending" || response.data.status == "processing") {
            this.againValidationBold();
          }
  
          if (response.data.status == "approved") { //Descomentar para prueba
            //clearInterval(this.timer); // Detener el temporizador
            this.loadingSearch = false;
            this.text = "¡PAGO REALIZADO EXITOSAMENTE!";
            setTimeout(() => {
              this.onFinish(true);
            }, 1000);
          }

          if(response.data.status == "declined" || response.data.status == "error" || response.data.status == "cancelled"){
            clearInterval(this.timer); // Detener el temporizador
            this.loadingSearch = false;
            this.errorMessage = "PAGO RECHAZADO";
            this.text = "PAGO RECHAZADO";
            setTimeout(() => {
              this.onFinish(false);
            }, 1.5 * 1000);
          }


  
          if (!response.success) {
            this.errorMessage = "Ocurrió un error al consultar el estado de la transacción.";
          }
          
        } catch (error) {
          this.loadingSearch = false;
          console.error(error)
          this.againValidationBold();
        }
      },
      startTimer() {
        this.timer = setInterval(() => {
          if (this.timeLeft > 0) {
            this.timeLeft--;
          } else {
            clearInterval(this.timer);
            this.cancelTransaction();
          }
        }, 1000);
      },
      cancelTransaction() {
        this.showQR = false;
        this.text = "La transacción ha sido cancelada.";
      },
    },
    mounted() {
      if(this.bold_status){
        this.bold_terminal = BoldTerminalHelper.getSelectedTerminal();
      }
      if (this.order != null) {
        if(this.order.qr_bancomlombia){
          this.createOrderQRBancolombia();
        }else{
          this.createOrder();
        }
      }
    },
  };
  </script>
  
    
<style scoped>

.container-button{
  width: 95%;
  padding: 10px 0px 10px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.send-button{
  width: 100%;
  background: #64B161;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  transition: all 1s;
}

.send-button label{
  color: #fff;
  margin-bottom: 0 !important;
  font-weight: 600;
  margin-top: 3px;
}

.send-button i:nth-child(1){
  color: #fff;
  margin-right: 6px;
}

.img-width{
  width: 60%;
}

.error-alert {
  color: #fff;
  background-color: #f44336;
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 5px;
  text-align: center;
  font-weight: bold;
}

.payment-screen {
  background: white;
  padding: 2rem;
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
}

.logo {
  width: 25%;
  margin-bottom: 2rem;
  border-radius: 50%;
}

.payment-instructions {
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  color: #333;
  font-weight: normal;
}

.total-amount {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 2rem;
}

.dataphone-container {
  background: #f5f5f5;
  border-radius: 12px;
  padding: 2rem;
  position: relative;
  margin: 0 auto;
  max-width: 400px;
}

.dataphone {
  background: white;
  border-radius: 8px;
  padding: 1rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.screen {
  background: #e0e0e0;
  height: 40px;
  margin-bottom: 1rem;
  border-radius: 4px;
}

.card-slot {
  background: #d0d0d0;
  height: 4px;
  margin: 1rem 0;
}

.keypad {
  background: #f0f0f0;
  padding: 1rem;
  border-radius: 4px;
}

.display {
  background: #90EE90;
  padding: 0.5rem;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.visa-text {
  color: #333;
}

.green-button-callout {
  position: absolute;
  right: 20px;
  bottom: 40px;
}

.circle {
  background: #4CAF50;
  color: white;
  padding: 1rem;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.8rem;
  line-height: 1.2;
}
</style>